var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('testimonies-carousel',{attrs:{"testimonies":_vm.testimonies,"showAddButton":!!_vm.currentUser},on:{"onClickAddTestimony":_vm.onClickAddTestimony}})}
var staticRenderFns = []

export { render, staticRenderFns }